import { useCallback, useMemo, useState } from 'react';
import {
  ILineOfCreditResponseType,
  LocTagInvite,
} from 'src/types/LineOfCredit';

type UseFilterTagInvitesProps = {
  loc: ILineOfCreditResponseType;
};

type UseFilterTagInvitesReturn = {
  initialTagInvitesLength: number;
  filteredTagInvites: LocTagInvite[];
  isUsingQuery: boolean;
  filterTagInvitesBySearch: (query: string) => void;
};

export const useFilterTagInvites = ({
  loc,
}: UseFilterTagInvitesProps): UseFilterTagInvitesReturn => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isUsingQuery, setIsUsingQuery] = useState<boolean>(false);

  const filteredTagInvites = useMemo(() => {
    return loc.tag_invites.filter((item) => {
      if (loc.id === item.id) {
        return false;
      }
      return item.name.toLowerCase().includes(searchQuery.toLowerCase());
    });
  }, [loc.id, loc.tag_invites, searchQuery]);

  const initialTagInvitesLength = useMemo(() => {
    return loc.tag_invites.filter(({ id }) => loc.id !== id).length;
  }, [loc.id, loc.tag_invites]);

  const filterTagInvitesBySearch = useCallback((query = '') => {
    setSearchQuery(query);
    setIsUsingQuery(!!query);
  }, []);

  return {
    initialTagInvitesLength,
    filteredTagInvites,
    isUsingQuery,
    filterTagInvitesBySearch,
  };
};
